// extracted by mini-css-extract-plugin
export default {"word":"WordPracticeView_word__MHxC6"};